import * as styles from './SubmitReportActionInfo.css';

/**
 * SubmitReportActionInfo
 *
 * Read-only informational panel displayed inside ActionDialog when the
 * Submit Report action type is selected. Explains what the action does
 * so admins understand it requires no additional configuration.
 */
export function SubmitReportActionInfo() {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>How Submit Report Works</h3>
      <p className={styles.body}>This action automatically creates a moderation case in the respective topic moderation queue.</p>
      <p className={styles.note}>Moderation cases will be attributed to the Soteria system, not to a specific user account.</p>
    </div>
  );
}
